// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ccbb9e8f","84":"9d8a4384","247":"b40fe0ce","627":"a5a192c7","834":"dafe8256","867":"5e61a815","923":"629be987"}[chunkId] + ".chunk.js";
};